import { Form, Modal } from "antd";
import React from "react";
import { CreateSoilPointDto } from "../../../api";
import { soilPointsColumns } from "../form/columns";

interface SoilPointFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateSoilPoint: (values: CreateSoilPointDto) => void;
}

export const SoilPointForm: React.FC<SoilPointFormProps> = ({ visible, setVisible, onCreateSoilPoint }) => {
  const [form] = Form.useForm<CreateSoilPointDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateSoilPoint}>
        {soilPointsColumns.map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
          {inputNode}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
